import { render } from "./FollowModal.vue?vue&type=template&id=4c714491&scoped=true"
import script from "./FollowModal.vue?vue&type=script&lang=js"
export * from "./FollowModal.vue?vue&type=script&lang=js"

import "./FollowModal.vue?vue&type=style&index=0&id=4c714491&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c714491"]])

export default __exports__